import { SEGMENT_CATEGORY, SegmentCategory } from '../types/segment-category.type';

export const SEGMENT_CATEGORIES: SegmentCategory[] = [
  SEGMENT_CATEGORY.ENTREPRISE,
  SEGMENT_CATEGORY.ECO,
  SEGMENT_CATEGORY.RELAY,
];

export const SEGMENT_CATEGORY_LABELS: Record<SegmentCategory, string> = {
  [SEGMENT_CATEGORY.ENTREPRISE]: 'Entreprise',
  [SEGMENT_CATEGORY.ECO]: 'Éco-acteur',
  [SEGMENT_CATEGORY.RELAY]: 'Point relais',
};

export const ALL_SEGMENT_CATEGORIES = 'all';

export type SegmentCategoryFilter = SegmentCategory | typeof ALL_SEGMENT_CATEGORIES;
